import { useEffect } from 'react'
import './style.css'
import TopBar from '../../components/general/topbar/TopBar';
import Footer from '../../components/general/footer/Footer';
import { useNavigate } from 'react-router-dom';
import ButtonMinimalist from '../../components/general/button/ButtonMinimalist';
import ProductosBanner from '../../assets/images/banners/webps/interior2.webp'
import { Helmet } from 'react-helmet';

export default function Products() {

  let navigate = useNavigate();

  useEffect(() => {
    window.scroll(0,0);
  })

  const metaTags = {
    title: "Productos",
    description: "Contamos con venta de repuestos e insumos para refrigeracion familiar, comercial y automotriz",
    url: "https://www.nicolinirefrigeracion.com.ar/productos"
  }

  return (
    <div className='Products'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={ProductosBanner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={ProductosBanner} />
      </Helmet>

      <TopBar />
      <div className='pageDisplay' id='p1'>
        <div id="div1">
          <h2 className='title'>Transporte</h2>
          <p className='text'>{"Realizamos la venta e instalacion de equipos de frio para transporte. Así tambien realizamos el mantenimiento y servicio técnico de los mismos"}</p>
        </div>
        <div id="div2">
          <ButtonMinimalist text={"Ir a Transporte"} onClick={() => navigate("transporte")} />
        </div>
      </div>
      <div className='pageDisplay' id='p2'>
        <div id="div1">
          <h2 className='title'>Insumos</h2>
          <p className='text'>{"Contamos con venta de repuestos e insumos para refrigeracion familiar, comercial y automotriz"}</p>
        </div>
        <div id="div2">
          <ButtonMinimalist text={"Ir a Insumos"} onClick={() => navigate("insumos")} />
        </div>
      </div>
      <div className='pageDisplay' id='p3'>
        <div id="div1">
          <h2 className='title'>¿Querés transportar carga refrigerada?</h2>
          <p className='text'>{"Te asesoramos en lo que necesites. Escribinos por nuestros canales de contacto o llamanos por telefono para resolver tus dudas"}</p>
        </div>
        <div id="div2">
          <a href='https://wa.me/5493434178703?text=%C2%A1Hola!+Quisiera+consultar+por+información+sobre+equipos+de+frío' target='_blank'><ButtonMinimalist text={"Contactate con nosotros"} /></a>
        </div>
      </div>
      <div className='pageDisplay' id='p4'>
        <div id="div1">
          <h2 className='title'>Aire Acondicionado</h2>
          <p className='text'>{"Pedí tu equipo a medida. Trabajamos desde 3.000 a 18.000 frigorías. Escribinos para mas información"}</p>
        </div>
        <div id="div2">
          <a href='https://wa.me/5493434178703?text=%C2%A1Hola!+Quisiera+consultar+precio+de+un+aire+acondicionado' target='_blank'><ButtonMinimalist text={"Pedí tu cotización"} /></a>
          <p className='text'>{"Consultá por tu equipo directamente con nosotros"}</p>
          <ButtonMinimalist text={"Calculadora de aire acondicionado"} onClick={() => navigate("/calculadora-aire-acondicionado")} />
          <p className='text'>{"¿No sabés que potencia necesitás para tu aire? Averigualo con nuestra calculadora de potencia para aire acondicionado"}</p>
        </div>
      </div>
      <Footer />
    </div>
  )
}